/**
 * Enum for icon types.
 */
export enum IconType {
  INFO = 'info_i',
  SUCCESS = 'check',
  WARNING = 'warning',
  ERROR = 'report'
}
